// extracted by mini-css-extract-plugin
export default {"mainIframeWidth":"375px","iframe":"style__d946602bffa2674f7689"};